const DEFAULT_API_URL = "https://api-crm.electrovel.com.ua";

export const BASE_URL = (
  process.env.REACT_APP_API_URL || DEFAULT_API_URL
).replace(/\/$/, "");
